import Service from 'react-reservice';

import chartAnalysisService from '@webtrader/core/services/analysis/chart/chartAnalysisService';
import featurePopupAnalysisService from '@webtrader/core/services/analysis/featurePopup/featurePopupAnalaysisService';
import orderAnalysisService from '@webtrader/core/services/analysis/order/orderAnalysisService';
import pageAnalaysisService from '@webtrader/core/services/analysis/page/pageAnalaysisService';
import signalAnalysisService from '@webtrader/core/services/analysis/signal/signalAnalysisService';
import superPropertiesService from '@webtrader/core/services/analysis/superProperties/superPropertiesService';
import userAnalysisService from '@webtrader/core/services/analysis/user/userAnalysisService';

class MixpanelAnalysisService extends Service {
  public user = userAnalysisService;
  public superProperties = superPropertiesService;
  public order = orderAnalysisService;
  public page = pageAnalaysisService;
  public chart = chartAnalysisService;
  public featurePopup = featurePopupAnalysisService;
  public signal = signalAnalysisService;
}

const mixpanelAnalysisService = new MixpanelAnalysisService();
export default mixpanelAnalysisService;
